import HostingsiteBase from "./Hostingsite"
import { Subnet } from "./Subnet"

export default class MoveSubnetRequest {
    subnet?: Subnet
    hosting_site_name?: string
    hosting_site_address?: string
    hosting_site?: HostingsiteBase
}